import { Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faLightbulb, faRocket } from "@fortawesome/free-solid-svg-icons";

const EmailSettingFooter = () => {
  return (
    <Row className="g-4">
      <Col md={4}>
        <Card
          className="h-100 border-0 text-center"
          style={{
            background: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '16px',
            border: '1px solid rgba(0, 212, 255, 0.1)'
          }}
        >
          <Card.Body className="p-4">
            <FontAwesomeIcon 
              icon={faLightbulb} 
              size="2x" 
              className="text-warning mb-3"
              style={{ filter: 'drop-shadow(0 0 8px rgba(245, 158, 11, 0.3))' }}
            />
            <h5 className="fw-semibold mb-2">Smart Lead Detection</h5>
            <p className="text-muted small">
              AI automatically identifies and categorizes potential leads from your email communications.
            </p>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card 
          className="h-100 border-0 text-center"
          style={{
            background: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '16px',
            border: '1px solid rgba(0, 212, 255, 0.1)'
          }}
        >
          <Card.Body className="p-4">
            <FontAwesomeIcon 
              icon={faRocket} 
              size="2x" 
              className="text-info mb-3"
              style={{ filter: 'drop-shadow(0 0 8px rgba(59, 130, 246, 0.3))' }}
            />
            <h5 className="fw-semibold mb-2">Automated Responses</h5>
            <p className="text-muted small">
              Intelligent response suggestions and automated follow-up sequences powered by neural networks.
            </p>
          </Card.Body>
        </Card>
      </Col>
      <Col md={4}>
        <Card 
          className="h-100 border-0 text-center"
          style={{
            background: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '16px',
            border: '1px solid rgba(0, 212, 255, 0.1)'
          }}
        >
          <Card.Body className="p-4">
            <FontAwesomeIcon 
              icon={faChartLine} 
              size="2x" 
              className="text-success mb-3"
              style={{ filter: 'drop-shadow(0 0 8px rgba(16, 185, 129, 0.3))' }}
            />
            <h5 className="fw-semibold mb-2">Performance Analytics</h5>
            <p className="text-muted small">
              Real-time insights into email performance, engagement rates, and conversion metrics.
            </p>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default EmailSettingFooter